import axios from "axios";
import Cookies from "js-cookie";

// API 환경 설정
const isDevelopment = process.env.NODE_ENV === "development";
// const isDevelopment = false; //
// 현재 환경 정보 출력 (개발 시 확인용)
console.log(
  `현재 API 환경: ${isDevelopment ? "개발(Development)" : "배포(Production)"}`
);

// API 기본 URL
const BASE_API_URL = isDevelopment
  ? "https://dev-be.aptconcierge.ai/api"
  : "https://prod-be.aptconcierge.ai/api";

// Auth 서비스 URL
const AUTH_API_URL = "https://admin.aptconcierge.ai";

// 쿠키 관련 설정
const COOKIE_CONFIG = {
  // 쿠키 키 이름
  KEYS: {
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
    USER_INFO: "user_info",
  },

  // 쿠키 만료 시간 (일 단위)
  EXPIRES: {
    ACCESS_TOKEN: 1, // 1일
    REFRESH_TOKEN: 30, // 30일
    USER_INFO: 7, // 7일
  },

  // 쿠키 옵션
  OPTIONS: {
    path: "/",
    secure: !isDevelopment, // 개발 환경에서는 false, 배포 환경에서는 true
    sameSite: "strict",
  },
};

// 각 API 엔드포인트
const API_ENDPOINTS = {
  // 현재 환경 (개발/배포)
  IS_DEVELOPMENT: isDevelopment,

  // 기본 URL (다른 곳에서 필요할 경우)
  BASE_URL: BASE_API_URL,
  AUTH_URL: AUTH_API_URL,

  // 쿠키 설정
  COOKIE_CONFIG,

  // 사용자 정보 조회
  USER_INFO: `${BASE_API_URL}/mobile/user`,

  // 토큰 갱신
  REFRESH_TOKEN: `${AUTH_API_URL}/api/auth/refresh`,

  // 하자 점검 관련 API
  SUBMIT_INSPECTION: `${BASE_API_URL}/api/mobile/submit-inspection`,
  GET_INSPECTIONS: `${BASE_API_URL}/api/mobile/inspections`,
  GET_INSPECTION_DETAIL: (id) => `${BASE_API_URL}/api/mobile/inspections/${id}`,

  // 기타 API 엔드포인트들 추가 가능
};

// axios 인터셉터 설정 (토큰 자동 추가)
const setupAxiosInterceptors = () => {
  // 요청 인터셉터 - 모든 요청에 access token 추가
  axios.interceptors.request.use(
    (config) => {
      const accessToken = Cookies.get(COOKIE_CONFIG.KEYS.ACCESS_TOKEN);
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // 응답 인터셉터 - 401 에러 시 토큰 갱신 시도
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const refreshToken = Cookies.get(COOKIE_CONFIG.KEYS.REFRESH_TOKEN);
          if (refreshToken) {
            const response = await axios.post(API_ENDPOINTS.REFRESH_TOKEN, {
              refreshToken: refreshToken,
            });

            if (response.data.accessToken) {
              // 새로운 access token 저장
              Cookies.set(
                COOKIE_CONFIG.KEYS.ACCESS_TOKEN,
                response.data.accessToken,
                {
                  expires: COOKIE_CONFIG.EXPIRES.ACCESS_TOKEN,
                  ...COOKIE_CONFIG.OPTIONS,
                }
              );

              // 원래 요청 재시도
              originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;
              return axios(originalRequest);
            }
          }
        } catch (refreshError) {
          console.error("토큰 갱신 실패:", refreshError);
          // 토큰 갱신 실패 시 로그인 페이지로 리다이렉트
          window.location.href = "/";
        }
      }

      return Promise.reject(error);
    }
  );
};

// 인터셉터 설정 함수를 API_ENDPOINTS에 추가
API_ENDPOINTS.setupAxiosInterceptors = setupAxiosInterceptors;

export default API_ENDPOINTS;
